export function createMatricesFromItems(items) {
  // Group items by parentID

  const groupedItems = {};
  items.forEach((item) => {
    if (!groupedItems[item.parentID]) {
      groupedItems[item.parentID] = [];
    }
    groupedItems[item.parentID].push(item);
  });

  // Create matrices for each group of items
  const matrices = {};
  Object.keys(groupedItems).forEach((parentID) => {
    const itemsForParent = groupedItems[parentID];
    const maxRow = Math.max(...itemsForParent.map((item) => item.rowIndex)) + 1;
    const maxCol =
      Math.max(...itemsForParent.map((item) => item.columnIndex)) + 1;
    const matrix = Array.from({ length: maxRow }, () =>
      Array(maxCol).fill(null)
    );
    itemsForParent.forEach((item) => {
      if (item.holdID === null) delete item.holdID;
      if (item.holdColor === null) delete item.holdColor;
      if (item.tierID === null) delete item.tierID;
      if (item.tierColor === null) delete item.tierColor;
      if (item.parentType === "matrix")
        matrix[item.rowIndex][item.columnIndex] = item;
      if (item.parentType === "table") matrix[0][item.index] = item;
    });

    matrices[parentID] = matrix;
  });
  return matrices;
}


export function getRowLabelNew(
  rowIndex,
  totalRows,
  isReverse,
  useNumbers,
  startFrom,
) {
  if(!startFrom) return "";
  if (useNumbers) {
    // Ensure startFrom is treated as a number for numeric labels
    const startNumber =
      typeof startFrom === "number" ? startFrom : parseInt(startFrom, 10);
    let label;
    if (isReverse) {
      // Calculate label when counting in reverse from the total number of rows
      label = startNumber + totalRows - 1 - rowIndex;
    } else {
      // Calculate label when counting normally
      label = startNumber + rowIndex;
    }
    return label.toString();
  } else {
    // Ensure startFrom is treated as a string for letter labels
    const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const startChar =
      typeof startFrom === "string"
        ? startFrom.toUpperCase()
        : String.fromCharCode(65 + (startFrom % 26));
    
    const startIndex = getAlphabetIndex(startChar); // Convert startFrom to its alphabet index
    let adjustedIndex;

    if (isReverse) {
      adjustedIndex = startIndex + totalRows - 1 - rowIndex;
    } else {
      adjustedIndex = startIndex + rowIndex;
    }

    return getRepeatingAlphabetLabel(adjustedIndex);
  }
}

// Helper function to convert a letter string (e.g., "A", "AA") to its 0-based index
function getAlphabetIndex(label) {
  const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  let index = 0;

  for (let i = 0; i < label.length; i++) {
    index *= 26;
    index += alphabet.indexOf(label[i]) + 1;
  }

  return index - 1; // Convert to 0-based index
}

// Helper function to generate repeating alphabet labels (e.g., A, BB, CCC)
function getRepeatingAlphabetLabel(index) {
  const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const letter = alphabet[index % 26]; // Wrap around the alphabet
  const repeatCount = Math.floor(index / 26) + 1; // Determine the repetition count
  return letter.repeat(repeatCount); // Repeat the letter
}
